import { get, put } from '@api/request';

export async function fetchAppealPanelOverview(
  { appealsService },
  authenticationToken
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/overview`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelStatusCode(
  { appealsService },
  authenticationToken
) {
  const url = `${appealsService}/appraisal/codes?type=Appeals&name=Panel Status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelStatus(
  { appealsService },
  authenticationToken,
  { panelID }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAppealPanelStatus(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/status`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}